import React, { Component, createRef } from "react";

import PropTypes from "prop-types";

import NavLink2 from "components/NavLink2";
import NavDropDown from "components/NavDropDown";

import { Link } from "react-router-dom";

class NavBar2 extends Component {
  state = {
    menuOpen: false
  };

  wrapperRef = createRef();

  componentDidMount() {
    document.addEventListener("mousedown", this.onClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.onClickOutside);
  }

  handleClick = () => {
    this.setState(state => ({
      menuOpen: !state.menuOpen
    }));
  };

  onClickOutside = event => {
    if (
      this.wrapperRef &&
      this.wrapperRef.current &&
      !this.wrapperRef.current.contains(event.target)
    ) {
      this.setState({ menuOpen: false });
    }
  };

  render() {
    const logoProps = {
      src: this.props.logo
    };

    return (
      <nav className="navBar2">
        <ul
          className={
            this.props.authenticated ? "links" : "links unauthed-links"
          }
        >
          {this.props.links &&
            this.props.links.map((link, index) => {
              return <NavLink2 key={index} link={link} />;
            })}
        </ul>
        <div
          className={"menu-icon-container"}
          onClick={this.handleClick}
          ref={this.wrapperRef}
        >
          <i className="fas fa-bars" />
          <NavDropDown open={this.state.menuOpen} links={this.props.links} />
        </div>
        <a target="_blank" rel="noopener noreferrer" href="https://go4.io/">
          <img {...logoProps} className="alt-logo" alt="Go4" />
        </a>
      </nav>
    );
  }
}

NavLink2.contextTypes = {
  currentUser: PropTypes.object,
  location: PropTypes.object,
  router: PropTypes.object
};

export default NavBar2;
